import { useTypedContext } from '../../../../../../../../../../../../../../../../../../../../../../../hooks/useTypedContext';
import { ReactStateTuple } from '../../../../../../../../../../../../../../../../../../../../../../../interfaces/ui';
import { ValidationResult } from '../../../../../../../../../../../../../../../types';
import { ValidationContext } from '../../../../../../../../../../../types';
import { useCallback } from 'react';
import { cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';
import {
  QuestionValidConversationTemplateItem,
  ValidConversationTemplateItemType,
} from '../../../../../../../../../../../../../../../../../../../../../../../interfaces/conversations';
import { getEmptyQuestionBasedOnType } from '../helpers';

export const useHandleApply = (id: string, onResolve: () => void) => {
  const [validation, setValidation] =
    useTypedContext<ReactStateTuple<ValidationResult>>(ValidationContext);

  return useCallback(() => {
    let validationCopy = cloneDeep(validation);
    const newQuestionGuid = uuid();

    validationCopy.template.content = validationCopy.template.content.map(
      (item) => {
        if (
          item.type !== ValidConversationTemplateItemType.Question ||
          item.value.guid !== id
        )
          return item;

        return {
          ...item,
          resource_id: newQuestionGuid,
          value: getEmptyQuestionBasedOnType(newQuestionGuid, item.value.type),
        } as QuestionValidConversationTemplateItem;
      }
    );

    validationCopy.ready_to_complete = false;
    setValidation(validationCopy);
    onResolve();
  }, [id, onResolve, setValidation, validation]);
};
